import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed, PropType } from "vue";
import { Document } from "@/types";
import { documentToSlug } from "@/tools/document";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentSlug',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const slug = computed(() => documentToSlug(props.document));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "DocumentSlug",
    innerHTML: slug.value
  }, null, 8, _hoisted_1))
}
}

})